<app-top-menu-two *ngIf="this.showTopMenu"></app-top-menu-two>
<div class="main" [ngClass]="{'responsive': this.showTopMenu}" *ngIf="this.userConfirmation" style="max-width: 800px; margin: 0 auto;">

  <!--Nav Top-->
  <app-nav-top title="Perfil" *ngIf="this.showTopMenu" (back)="goback()"></app-nav-top>
  
    <div class="header" *ngIf="this.user">
      <div class="user-greeting-container">
        <div class="greeting-icon">
          <span>{{ this.user.name | slice:0:1 | uppercase }}</span>
        </div>
        <div class="greeting-content">
          <span class="greeting-label">Bem vindo,</span>
          <span class="greeting-name">{{ this.user.name }}</span>
        </div>
      </div>
        <div class="box-cashback">
          <div class="cashback-left">
            <div class="icon-bg">
              <div class="icon-wallet"></div>
            </div>
            <div class="cashback-details">
              <span class="cashback-label">Seu Cashback</span>
              <span class="cashback-value">{{ this.user.cashback | currency: 'BRL' }}</span>
            </div>
          </div>
          <div class="cashback-right" style="color: var(--primary-color);" (click)="navigateCashbackHistory()">
            <span>Ver histórico</span>
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </div>
    </div>
    <div class="box-option">
      <ng-container *ngIf="this.fidelityGet && this.fidelityUser">
        <div class="option" (click)="navigateFidelity()" *ngIf="this.fidelityUser.fidelity == true">
          <div class="icon-hand-coins icones"></div>
          <div class="content-option">
            <span class="title-option">Fidelidade</span> 
            <span class="description-option">Minha fidelidade</span>
          </div>
          
          <div class="option-nav">
            <ng-container *ngIf="this.fidelityUser.fidelityApproved">
              <div class="circle-red-new">
                <span>1</span>
              </div>
            </ng-container>
            <div class="arrow-option">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </div>

        </div>
      </ng-container>

      <div class="option" (click)="navigateCoupons()">
        <div class="icon-ticket-percent icones"></div>
        <div class="content-option">
          <span class="title-option">Cupons</span>
          <span class="description-option">Meus cupons de desconto</span> 
        </div>
        <div class="option-nav">
          <ng-container *ngIf="this.user.coupons">
            <div class="circle-red-new" *ngIf="this.couponsQuantity > 0">
              <span>{{ this.couponsQuantity }}</span>
            </div>
          </ng-container>
          <div class="arrow-option">
            <i class="fa-solid fa-chevron-right"></i>
          </div>
        </div>
      </div>

      <!-- <div class="option">
        <div class="icon-map-pinned icones disabled-option"></div>
        <div class="content-option disabled-option">
          <span class="title-option">Endereços</span> 
          <span class="description-option">Meus endereços de entrega</span>
        </div>
        <div class="option-nav">
          <div class="button-short">
            <button>Em breve</button>
          </div>
        </div>
      </div> -->

      <!-- <div class="option option-danger" (click)="openDeleteAccount()">
          <div class="icon-trash-2 icones icon-danger"></div>
          <div class="content-option">
            <span class="title-option title-danger">Excluir conta</span>
            <span class="description-option">Solicite a exclusão permanente da sua conta</span>  
          </div>
          <div class="option-nav">
            <div class="arrow-option icon-danger">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </div>
      </div> -->

      <div class="option" (click)="this.openLogOut = true">
          <!-- <i class="fa-solid fa-right-to-bracket"></i> -->
          <div class="icon-log-out icones"></div>
          <div class="content-option">
            <span class="title-option">Sair</span>
            <span class="description-option">Sair do seu perfil</span>  
          </div>
          <div class="option-nav">
            <div class="arrow-option">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
          </div>
      </div>
        
    </div>
</div>



<div *ngIf="!this.userConfirmation" [ngClass]="{'responsive-login': this.showTopMenu}" >
    <div class="container" style="overflow: auto;">
      <div class="navegation-header d-flex align-items-center">
        <div class="box-title">
          <h3 style="margin-bottom: 0px;">Entre ou Cadastre-se</h3>
        </div>
      </div>
      <form (ngSubmit)="submitForm()">
        <div style="padding-bottom: 90px;" class="fist-box">
          <div class="user-data">
            <div class="d-flex px-2 flex-column box-data">
              <span>Número de celular</span>
              <input [disabled]="submit" class="form-control" style="padding-right: 35px;" type="text" placeholder="(_ _) _ _ _ _ _ - _ _ _ _" (keyup)="validatePhoneNumber()" [(ngModel)]="this.phoneNumber" name="phoneNumber" [ngClass]="{'is-valid': this.corretFormatPhoneNumber == true, 'is-invalid': this.corretFormatPhoneNumber == false}" maxlength="14" #inputPhone required>
              <span class="error-input" *ngIf="this.corretFormatPhoneNumber == false">Informe um número válido.</span>
            </div>
            <div class="d-flex px-2 flex-column box-data">
              <span>Nome e sobrenome</span>
              <input [disabled]="submit" formatation class="form-control" style="padding-right: 35px;" type="text" [(ngModel)]="name" name="name" placeholder="Nome e sobrenome" [ngClass]="{'is-valid': this.lengthInputName == true, 'is-invalid': this.lengthInputName == false}" (keyup)="onInputChangeName($event)" required="true" #inputName>
              <span class="error-input" *ngIf="this.lengthInputName == false">Digite pelo menos 3 caracteres.</span>
            </div>
            <div class="d-flex px-2 flex-column box-data">
              <span *ngIf="!this.requiredBirth">Data de nascimento (Opcional)</span>
              <span *ngIf="this.requiredBirth">Data de nascimento</span>
              <input [disabled]="submit" formatation class="form-control" autocomplete="off" style="padding-right: 35px;" type="text" [(ngModel)]="birthData" (keyup)="validateBirthDate()" name="birthData" placeholder="DD/MM/AAAA" [ngClass]="{'is-valid': this.correctFormatBirth == true, 'is-invalid': this.correctFormatBirth == false}" required="true" maxlength="10" #inputBirth>
              <span class="error-input" *ngIf="this.correctFormatBirth == false">Por favor, insira uma data válida.</span>
            </div>
          </div>
        </div>
        <div class="bottom-navegation">
          <div class="bottom-navegation__box">
            <button type="submit" class="buttonConfirmation" *ngIf="this.alterationButton" [disabled]="!lengthInputName || !lengthInputPhone || (!lengthInputBirth || correctFormatBirth == false) || submit">
                Entrar
            </button>
            <button type="submit" class="buttonConfirmation" *ngIf="!this.alterationButton" [disabled]="!lengthInputName || !lengthInputPhone || (!lengthInputBirth || correctFormatBirth == false) || submit">
                Cadastrar
            </button>
          </div>
        </div>
    </form>
    </div>
    
</div>

<div class="modal" [ngClass]="{'show': openLogOut}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title">Sair</h1>
      </div>
      <div class="modal-body">
        <span>Deseja sair da sua conta?</span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn modal-btn-negative" (click)="this.openLogOut = false">Fechar</button>
        <button type="button" class="btn modal-btn-positive" (click)="this.disconnectUser()">Sair</button>
      </div>
    </div>
  </div>
</div>


<!-- Modal de Exclusão de Conta -->
<div class="modal" [ngClass]="{'show': openDeleteModal}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-delete-content">

      <!-- Estado 1: Confirmação -->
      <ng-container *ngIf="deleteAccountState === 'confirm'">
        <div class="modal-header modal-delete-header">
          <div class="delete-icon-container">
            <i class="fa-solid fa-triangle-exclamation delete-warning-icon"></i>
          </div>
          <h1 class="modal-title modal-delete-title">Excluir conta</h1>
        </div>
        <div class="modal-body modal-delete-body">
          <p class="delete-description">Você confirma a solicitação de <strong>exclusão da sua conta</strong>?</p>
          <p class="delete-warning-text">Esta ação não pode ser desfeita. Nossa equipe irá analisar sua solicitação.</p>
        </div>
        <div class="modal-footer modal-delete-footer">
          <button type="button" class="btn modal-btn-negative" (click)="closeDeleteModal()">Cancelar</button>
          <button type="button" class="btn btn-delete-confirm" (click)="confirmDeleteRequest()">Sim</button>
        </div>
      </ng-container>

      <!-- Estado 2: Carregando -->
      <ng-container *ngIf="deleteAccountState === 'loading'">
        <div class="modal-body modal-loading-body">
          <div class="loading-spinner">
            <div class="spinner-ring"></div>
          </div>
          <span class="loading-text">Processando solicitação...</span>
        </div>
      </ng-container>

      <!-- Estado 3: Sucesso -->
      <ng-container *ngIf="deleteAccountState === 'success'">
        <div class="modal-body modal-success-body">
          <div class="success-icon-container">
            <i class="fa-solid fa-check success-check-icon"></i>
          </div>
          <h2 class="success-title">Tudo certo!</h2>
          <p class="success-description">Nossa equipe entrará em contato para finalizar os passos para exclusão da sua conta.</p>
        </div>
        <div class="modal-footer modal-success-footer">
          <button type="button" class="btn btn-success-close" (click)="closeDeleteModal()">Fechar</button>
        </div>
      </ng-container>

    </div>
  </div>
</div>

<!-- <app-bottom-menu></app-bottom-menu> -->
